// extracted by mini-css-extract-plugin
export default {"firstOrder__container":"FirstOrder_firstOrder__container__potns","heading":"FirstOrder_heading__WVwj6","grid":"FirstOrder_grid__ONN6A","grid__item":"FirstOrder_grid__item__qXZ+G"};